import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, fileUrl } from "@/lib/api";
import { BriefcaseBusiness, Search, Sparkles, Users } from "lucide-react";

export default function CreatorDirectoryPage() {
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  const [type, setType] = useState("all");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    const timer = setTimeout(async () => {
      setLoading(true);
      try {
        const r = await api.get("/creator-discovery", { params: { q, account_type: type, limit: 40 } });
        if (active) setRows(r.data);
      } finally {
        if (active) setLoading(false);
      }
    }, 180);
    return () => { active = false; clearTimeout(timer); };
  }, [q, type]);

  return (
    <div className="space-y-6" data-testid="creator-directory">
      <section className="brutal-card bg-sage p-6">
        <div className="flex items-center gap-3 mb-2"><BriefcaseBusiness size={24} /><div className="text-xs uppercase tracking-[0.18em] font-bold">HAEVEN Directory</div></div>
        <h1 className="text-4xl">Find people worth knowing and working with.</h1>
        <p className="mt-2 max-w-3xl">Discover creators, businesses, and organizations based on shared interests, real offerings, and collaboration intent—not just follower counts.</p>
      </section>

      <section className="grid sm:grid-cols-[1fr_180px] gap-3">
        <label className="brutal-card bg-card px-3 py-2 flex items-center gap-2"><Search size={16} /><input className="bg-transparent outline-none w-full" placeholder="Search skills, interests, services…" value={q} onChange={(e) => setQ(e.target.value)} /></label>
        <select className="brutal-input px-3 py-2" value={type} onChange={(e) => setType(e.target.value)}><option value="all">Everyone</option><option value="creator">Creators</option><option value="business">Businesses</option><option value="organization">Organizations</option></select>
      </section>

      {loading ? <div className="brutal-card bg-card p-6">Finding useful matches…</div> : (
        <section className="grid md:grid-cols-2 gap-4">
          {rows.length === 0 && <div className="brutal-card bg-card p-6 md:col-span-2">No matches yet. Try a broader search.</div>}
          {rows.map((row) => <article key={row.id} className="brutal-card bg-card p-5">
            <div className="flex items-start gap-4">
              <div className="w-14 h-14 rounded-xl border-2 border-foreground overflow-hidden bg-accent flex items-center justify-center text-xl font-bold shrink-0">{row.avatar_path ? <img alt="" src={fileUrl(row.avatar_path)} className="w-full h-full object-cover" /> : (row.display_name?.[0] || "?")}</div>
              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2 flex-wrap"><h2 className="text-xl">{row.display_name}</h2><span className="text-[10px] uppercase tracking-wider border border-foreground rounded px-2 py-0.5">{row.account_type}</span></div>
                <div className="text-xs text-muted-foreground">@{row.username}</div>
                {row.headline && <p className="mt-2 text-sm">{row.headline}</p>}
                <div className="mt-3 flex gap-2 flex-wrap text-xs">{row.shared_interests?.slice(0, 4).map((i) => <span key={i} className="bg-sage border border-foreground rounded px-2 py-1">{i}</span>)}</div>
                <p className="text-xs mt-3 flex items-center gap-1"><Sparkles size={12} /> {row.why}</p>
                <div className="mt-3 flex items-center gap-3 text-xs"><span className="inline-flex items-center gap-1"><Users size={12} /> {row.followers_count} followers</span><span>{row.offering_count} offerings</span>{row.accepting_collaborations && <span className="font-bold">Open to collaborate</span>}</div>
                <div className="mt-4 flex gap-2"><Link to={`/profile/${row.id}`} className="brutal-btn bg-primary text-primary-foreground px-3 py-2 text-xs">View profile</Link><Link to={`/messages/${row.id}`} className="brutal-btn bg-card px-3 py-2 text-xs">Message</Link></div>
              </div>
            </div>
          </article>)}
        </section>
      )}
    </div>
  );
}
